import { apiGet, apiPut, apiPost } from '../utils/axios';

const base_url = `/user`;

export const getUserProgress = (id) => {
  return apiGet(`${base_url}/${id}/progress`);
};

export const updateUser = (id, data) => {
  return apiPut(`${base_url}/${id}/update`, {
    ...data,
    isUpdatingPrograms: false,
  });
};

export const changePassword = (password) => {
  return apiPost(`${base_url}/change_password`, { password });
};

export const updateUserProgress = (id, data) => {
  return apiPost(`${base_url}/${id}/update_progress`, data);
};

export const evaluateAnswers = (data) => {
  return apiPost(`${base_url}/evaluate_answers`, data);
};

export const getUserSettings = () => {
  return apiGet(`${base_url}/settings`);
};

export const updateUserSettings = (settings) => {
  return apiPut(`${base_url}/settings`, settings);
};

export const getSurveyResponse = (email) => {
  return apiGet(`/typeform/responses?query=${email}`);
};
